import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Maintenance } from '../../../../class/Maintenance';
import { MaintenanceService } from '../../../../services/maintenance.service';
import { PreferenceService } from '../../../../services/preference.service';
import { SensorsListService } from '../../../../services/sensorslist.service';
import {
  ARCHIVE_MAINTENANCE,
  BUILD_MAINTENANCE,
} from '../../../maintenances-tab/maintenances-routing.constants';

import { TranslatePipe } from '@ngx-translate/core';
import HasPermissionDirective from '../../../../utils/directives/has-permission.directive';
import DurationPipe from '../../../../utils/pipes/duration.pipe';
import DynamicDatePipe from '../../../../utils/pipes/dynamic-date.pipe';
import ImperialPipe from '../../../../utils/pipes/imperial.pipe';

@Component({
  selector: 'maintenance-card',
  templateUrl: './maintenance-card.component.html',
  styleUrls: ['./maintenance-card.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ImperialPipe, DurationPipe, HasPermissionDirective, TranslatePipe, DynamicDatePipe],
})
export class MaintenanceCardComponent {
  public router = inject(Router);
  public preferenceService = inject(PreferenceService);
  private _sensorsListService = inject(SensorsListService);
  private _maintenanceService = inject(MaintenanceService);

  public $sensors = this._sensorsListService.$byUid();

  @Input() maintenance: Maintenance;

  public clickMaintenance(maintenance: number) {
    const state = this._maintenanceService.$valuesRecord().getStateofMaintenance(this.maintenance.uid);
    this.router.navigate([
      state === 'todo' ? BUILD_MAINTENANCE(maintenance) : ARCHIVE_MAINTENANCE(maintenance),
    ]);
  }
}
